module.exports = __webpack_public_path__ + "img/claims.7d3623f4.svg";